import { render } from "./AlertElement.vue?vue&type=template&id=72932876"
import script from "./AlertElement.vue?vue&type=script&lang=js"
export * from "./AlertElement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__